<template>
  <div class="small-header">
    <div class="small-header-title">{{ title }}</div>
    <div v-if="more" class="small-header-more" @click="$router.push(moreLink)">
      <span>查看更多</span>
      <img src="../../assets/img/sjt.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    more: {
      type: Boolean,
      default: false
    },
    moreLink: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.small-header {
  position: relative;
  height: 36px;
  .small-header-title {
    width: 150px;
    background-image: url("../../assets/img/bt_bg.png");
    background-size: cover;
    background-position: center center;
    font-size: 26px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 61px;
    text-align: center;
    padding-right: 19px;
    position: relative;
    top: -25px;
    z-index: 999999;
  }
  .small-header-more {
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #004089;
    cursor: pointer;
    margin-right: 30px;
    span {
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/small/smallHeader.vue